













import Datepicker from 'vuejs-datepicker';
import { IField } from './constants';

export default {
  props: {
    params: Object,
    value: [String, Date],
  },
  components: {
    Datepicker,
  },
} as IField;
